import React, { useCallback } from 'react';
import TextField from '@material-ui/core/TextField';

type PlainStringFieldProps = Omit<React.ComponentProps<typeof TextField>, 'onChange'> & {
    onChange: (value: string) => void;
};

const PlainStringField = ({
    value,
    onChange,
    ...props
}: PlainStringFieldProps): React.ReactElement | null => {
    const handleOnChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.value);
        },
        [onChange]
    );

    return (
        <TextField
            {...props}
            value={value}
            onChange={handleOnChange}
        />
    );
};

export default PlainStringField;
